<script>

import { Input } from 'element-ui'
export default {
  name: 'CargoElInput',
  extends: Input,
  props: {
    filterChars: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value(val) {
      this.$nextTick(this.resizeTextarea)
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val])
      }
      if (val) {
        this.$refs.input && this.$refs.input.setAttribute('title', val)
      } else {
        this.$refs.input && this.$refs.input.removeAttribute('title')
      }
    }
  },
  mounted() {
    this.setNativeInputValue()
    this.resizeTextarea()
    this.updateIconOffset()
    if (this.value) {
      this.$refs.input && this.$refs.input.setAttribute('title', this.value)
    } else {
      this.$refs.input && this.$refs.input.removeAttribute('title')
    }
  },
  methods: {
    handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return

      const pattern = new RegExp("['\"]", 'g')
      if (this.filterChars && pattern.test(event.target.value)) {
        console.log('-----filter-input-----', event)
        event.target.value = event.target.value.replaceAll(pattern, '')
      }

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return

      this.$emit('input', event.target.value)

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue)
    }
  }
}
</script>
